import Vue from "vue";
import base from "../../baseMarketing";

export default Object.assign(
    {
        apiUrl: "/sms",

        async get({ smsId }) {
            const url = this.userUrl({ path: `/${smsId}` });

            return Vue.http.get(url);
        },

        async list({ page = 0, filter, isAutomation }) {
            const url = this.userUrl({ path: `/${page}/list` });

            return Vue.http.get(url, {
                params: {
                    filter,
                    isAutomation
                },
            });
        },

        async delete({ smsId }) {
            const url = this.userUrl({ path: `/${smsId}` });

            return Vue.http.delete(url);
        },

        async setSendType({
            smsId,
            type,
            file,
            sourceNote,
            configurationSimplesSegmentedList,
        }) {
            const typeString = {
                ["EXTERNAL"]: "external",
                ["SIMPLE_SEGMENTED_LIST"]: "simple-segmented-list",
                ["WHOLE_DATABASE"]: "whole-database",
                ["CUSTOM_SEGMENTED_LIST"]: "custom-segmented-list",
            }[type];

            const url = this.userUrl({
                path: `/${smsId}/sendtype/${typeString}`,
            });

            let data = {};

            if (type === "EXTERNAL") {
                const options = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                };

                const data = new FormData();
                data.append("file", file);
                data.append("note", sourceNote);

                return Vue.http.post(url, data, options);
            }

            if (type === "SIMPLE_SEGMENTED_LIST") {
                data.configurationSimplesSegmentedList =
                    configurationSimplesSegmentedList;
            }

            if (type === "CUSTOM_SEGMENTED_LIST") {
                data = configurationSimplesSegmentedList;
            }

            return Vue.http.put(url, data);
        },

        async create({ 
            configuration,
            content,
            id,
            isAutomationFlow,
            schedulerDate,
            sendType,
            sourceNote,
            status,
            title,
         }) {
            const url = this.userUrl({ path: `/` });

            return Vue.http.post(url, {
                configuration,
                content,
                id,
                isAutomationFlow,
                schedulerDate,
                sendType,
                sourceNote,
                status,
                title,
            });
        },

        async edit({ smsId, data }) {
            const url = this.userUrl({ path: `/${smsId}` });

            return Vue.http.put(url, { ...data });
        },

        async test({ smsId, phoneNumber }) {
            const url = this.userUrl({ path: `/${smsId}/test` });

            return Vue.http.post(url, phoneNumber, {
                headers: {
                    "Content-Type": "text/plain",
                },
            });
        },

        async send({ smsId, schedulerDate }) {
            const url = this.userUrl({ path: `/${smsId}/send` });

            return Vue.http.post(url, {
                schedulerDate,
            });
        },

        async resend({ smsId }) {
            const url = this.userUrl({ path: `/${smsId}/resend` });

            return Vue.http.post(url);
        },

        async numbers({ smsId, page = 0, filter }) {
            const url = this.userUrl({ path: `/${smsId}/numbers/${page}` });

            return Vue.http.get(url, {
                params: { filter },
            });
        },

        async duplicate({ isAutomation, smsId }) {
            const url = this.userUrl({ path: `/${smsId}/copy` });

            return Vue.http.post(url, {
                isAutomation,
            });
        },
    },
    base
);
